<script type="text/javascript">

    import {http} from '../../../system/http.js';

    export default {

        data: function () {
            return {
            }
        },

        mounted: function () {
        },

        methods: {
            goLogin() {
                this.$event_bus.$emit('goLogin');
            },

            goSignUp() {
                this.$event_bus.$emit('goSignUp');
            },
        },
    };


</script>


<template id="choose-login-or-signup">

    <div class="row">

        <div class="col-sm-12">

            <div class="card-box login-box">
                <div class="row">
                    <div class="col-sm-6 login-signup-box border-right lsb-left">
                        <h4 class="text-uppercase font-bold m-b-25 m-t-0">{{ trans('online_booking.choose_login_signup_heading_1') }}</h4>
                        <p class="m-b-20">{{ trans('online_booking.choose_login_signup_desc_1') }}</p>
                        <button type="button" class="btn btn-lg btn-custom btn-block" @click="goLogin()">
                            <i class="zmdi zmdi-account"></i>
                            <span class="m-l-10">{{ trans('online_booking.login') }}</span>
                        </button>
                    </div>
                    <hr class="m-t-10 hr-dark only-sm">
                    <div class="col-sm-6 login-signup-box lsb-right">
                        <h4 class="text-uppercase font-bold m-b-25 m-t-0">{{ trans('online_booking.choose_login_signup_heading_2') }}</h4>
                        <p class="m-b-20">{{ trans('online_booking.choose_login_signup_desc_2') }}</p>
                        <button type="button" class="btn btn-lg btn-custom btn-trans btn-block" @click="goSignUp()">
                            <i class="zmdi zmdi-account-add"></i>
                            <span class="m-l-10">{{ trans('online_booking.create_new_user') }}</span>
                        </button>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>
